import * as Yup from 'yup';
import { endOfDay } from 'date-fns';
import { isUndefined } from 'lodash';
import ACCIDENT_PARTICIPANT_TYPES from '../../../containers/CascoCompensationContainer/options';
import { APPLICANT_TYPES } from '../../../constants/claim';
import { getLegalEntityValidator, getPhysicalEntityValidator } from '../claimApplicantDetailsValidation';
import { isArmenianCountry } from '../../../helpers/countryHelper';

const physicalSchema = Yup.object()
  .shape({
    firstName: Yup.string()
      .required('validationErrors.isRequired')
      .isCorrectLanguage(),
    lastName: Yup.string()
      .required('validationErrors.isRequired')
      .isCorrectLanguage(),
    passportNum: Yup.string()
      .min(3, 'validationErrors.wrongPassportNumber')
      .required('validationErrors.isRequired'),
    passportGivenDate: Yup.date()
      .nullable()
      .when(['isCitizen'], (isCitizen, schema) => {
        if (!isCitizen && !isUndefined(isCitizen)) {
          return schema
            .test(
              'passportGivenDate',
              'validationErrors.validityDate',
              (value) => new Date(value) <= endOfDay(new Date()),
            )
            .required('validationErrors.isRequired');
        }
        return schema;
      }),
    passportValidUntilDate: Yup.date()
      .nullable()
      .when(['isCitizen'], (isCitizen, schema) => {
        if (!isCitizen && !isUndefined(isCitizen)) {
          return schema.test(
            'validUntilDate',
            'validationErrors.validityDate',
            (value) => !value || endOfDay(new Date(value)) >= new Date(),
          );
        }
        return schema;
      }),
    passportFrom: Yup.string().when(['isCitizen'], (isCitizen, schema) => {
      if (!isCitizen && !isUndefined(isCitizen)) {
        return schema.required('validationErrors.isRequired');
      }
      return schema;
    }),
    stateNumber: Yup.string().required('validationErrors.isRequired'),
    transportManufacturer: Yup.object()
      .nullable()
      .required('validationErrors.isRequired'),
    transportModel: Yup.object()
      .nullable()
      .required('validationErrors.isRequired'),
    vin: Yup.string().required('validationErrors.isRequired'),
    applicantResidenceCountry: Yup.object()
      .nullable()
      .when('applicantIs', {
        is: (applicantIs) => applicantIs !== APPLICANT_TYPES[2].value,
        then: Yup.object().required('validationErrors.isRequired'),
      }),
    applicantResidenceState: Yup.object()
      .nullable()
      .when(['applicantResidenceCountry', 'applicantIs'], {
        is: (applicantResidenceCountry, applicantIs) => applicantIs !== APPLICANT_TYPES[2].value
          && isArmenianCountry(applicantResidenceCountry),
        then: Yup.object().required('validationErrors.isRequired'),
      }),
    applicantResidenceCityVillage: Yup.object()
      .nullable()
      .when(['applicantResidenceCountry', 'applicantIs'], {
        is: (applicantResidenceCountry, applicantIs) => applicantIs !== APPLICANT_TYPES[2].value
          && isArmenianCountry(applicantResidenceCountry),
        then: Yup.object().required('validationErrors.isRequired'),
      }),
    applicantResidenceStreet: Yup.string()
      .nullable()
      .when('applicantIs', {
        is: (applicantIs) => applicantIs !== APPLICANT_TYPES[2].value,
        then: Yup.string()
          .required('validationErrors.isRequired')
          .isCorrectLanguage(),
      }),
  })
  .concat(Yup.object().shape(getPhysicalEntityValidator()))
  .concat(
    Yup.object().shape(
      getPhysicalEntityValidator({
        citizenshipKey: 'participantCitizenship',
        birthdayKey: 'participantBDay',
        firstNameKey: 'participantFirstName',
        lastNameKey: 'participantLastName',
        passportKey: 'participantPassNum',
        passportGivenDateKey: 'participantPassGivenDate',
        passportValidUntilKey: 'participantPassValidUntilDate',
        passportFromKey: 'participantPassFrom',
        socCardKey: 'participantSocCard',
        when: 'participantIs',
        is: (participantIs) => participantIs === ACCIDENT_PARTICIPANT_TYPES[2].value,
      }),
    ),
  )
  .concat(Yup.object().shape(getLegalEntityValidator()));

export default physicalSchema;
